module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('l-header'), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: ({
      'background-color': _vm.$route.path != '/mall/booking' ? '#F2F2F2' : _vm.none
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _c('l-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40e55810"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/layout.vue
// module id = 564
// module chunks = 221